module.exports = __webpack_public_path__ + "static/second-section-box-eb26e0cd6e99bc9daaffe8a87bf6eefc.png";